import * as React from 'react';
import { Dispatch } from 'react-redux';
import { StoreState } from '../../../reducers/index';
const Translate = require('react-redux-i18n').Translate;

import { Container, CloseButton } from './styles';
import Utils from '../../../utils';
import { acceptCookie } from '../../../containers/App/actions';

interface StandardCookieProps {
	isDisplayed: boolean;
	url: string;
	dispatch: Dispatch<StoreState>;
}

const StandardCookie = ({
	isDisplayed,
	url,
	dispatch,
}: StandardCookieProps) => {

	const handleClick = () => {
		Utils.setCookie('areCookieAccepted', 'true', 90);
		dispatch(acceptCookie());
	};

	return (
		<Container className="StandardCookie" isDisplayed={isDisplayed}>
			<CloseButton onClick={handleClick}>
				{Utils.getSvgIcon('iconset_close-2')}
			</CloseButton>
			<Translate
				value="messages.cookie_notification"
				url={url}
				dangerousHTML={true}
			/>
		</Container>
	);
};

export default StandardCookie;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieNotification/StandardCookie/index.tsx